import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold text-black-main" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CpsButton = _resolveComponent("CpsButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.t("Deposit_Wallet_Qr_Code")), 1),
    _createElementVNode("img", {
      class: "mt-20 w-4/5 m-auto",
      src: _ctx.qrCodeDataUrl
    }, null, 8, _hoisted_2),
    _createVNode(_component_CpsButton, {
      class: "w-full mt-16",
      type: 'cancel',
      onClick: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("Deposit_Close")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}